import styled from 'styled-components';
import { CarNumberStyled } from '../CarNumberStyled';
import { rem } from 'polished';

export const CarNumberStyledDS = styled(CarNumberStyled)`
    color: #767676;
    font-size: ${rem('12px')};
`;
